<script setup>
const emit = defineEmits(["toggleMobile"]);
const props = defineProps({
  logo: {
    type: String,
    default: "Your logo",
  },
});

const dropdownVisible = ref(false);

let showT, hideT;

const open = () => {
  clearTimeout(hideT);
  showT = setTimeout(() => (dropdownVisible.value = true), 60);
};

const close = () => {
  clearTimeout(showT);
  hideT = setTimeout(() => (dropdownVisible.value = false), 140);
};

onBeforeUnmount(() => {
  clearTimeout(showT);
  clearTimeout(hideT);
});
</script>
<template>
  <nav
    class="relative flex items-center justify-between w-full font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <!-- Logo / Home Link -->
    <!-- <NuxtLink
      to="/"
      class="text-3xl md:text-4xl font-black drop-shadow-lg font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
    > -->
    <slot name="logo">{{ logo }}</slot>

    <!-- Nav Links (desktop) -->
    <div class="hidden md:flex items-center gap-6">
      <NuxtLink
        to="/"
        class="text-sm font-semibold uppercase text-iq-paragraph-color/80 hover:text-iq-paragraph-color transition"
        exactActiveClass="text-white"
      >
        Strona główna
      </NuxtLink>

      <!-- Proces tworzenia strony -->
      <NuxtLink
        to="/proces-tworzenia-strony"
        class="text-sm font-semibold uppercase text-iq-paragraph-color/80 hover:text-iq-paragraph-color transition"
        exactActiveClass="text-white"
      >
        Proces tworzenia strony
      </NuxtLink>

      <NuxtLink
        to="/cennik"
        class="text-sm font-semibold uppercase text-iq-paragraph-color/80 hover:text-iq-paragraph-color transition"
        exactActiveClass="text-white"
      >
        Cennik
      </NuxtLink>

      <div class="group overflow-hidden" @mouseenter="open" @mouseleave="close">
        <NuxtLink
          to="/pomoc"
          class="text-sm font-semibold uppercase text-iq-paragraph-color/80 hover:text-iq-paragraph-color transition cursor-pointer"
        >
          Przydatne informacje
        </NuxtLink>

        <!-- Dropdown -->

        <Transition name="fade-slide">
          <FlexuilibMegaPanel
            @mouseenter="open"
            @mouseleave="close"
            v-show="dropdownVisible"
            class="absolute inset-x-0 top-full transition z-30"
          />
        </Transition>
      </div>

      <NuxtLink
        to="/kontakt"
        class="text-center text-iq-paragraph-color/80 hover:text-iq-paragraph-color px-6 py-3 rounded-full bg-white/10 backdrop-blur-lg ring-1 ring-white/20 hover:bg-white/20 hover:ring-white/40 transition text-sm font-semibold uppercase"
        exactActiveClass="text-white"
      >
        Kontakt
      </NuxtLink>
    </div>

    <!-- Hamburger (mobile) -->

    <button
      @click="emit('toggleMobile')"
      class="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition md:hidden"
      aria-label="Open menu"
    >
      <!-- Hamburger Icon -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 text-black/80"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    </button>
  </nav>
</template>
<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: max-height 1s ease;
  overflow: hidden;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  max-height: 0;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  max-height: 1000px; /* set to something larger than your content */
}
</style>
